import { render, staticRenderFns } from "./CallForBids-page.vue?vue&type=template&id=52494221&scoped=true"
import script from "./CallForBids-page.vue?vue&type=script&lang=js"
export * from "./CallForBids-page.vue?vue&type=script&lang=js"
import style0 from "./CallForBids-page.vue?vue&type=style&index=0&id=52494221&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52494221",
  null
  
)

export default component.exports